import { getIsProductionEnvironment } from './environment';

export function logToConsole(error: unknown, ...rest: unknown[]): void {
  if (getIsProductionEnvironment()) {
    return;
  }

  // oxlint-disable-next-line no-console
  console.error(error, ...rest);
}

export function logDebug(message: string, data?: unknown): void {
  if (getIsProductionEnvironment()) {
    return;
  }

  const logTitle = `%c🔍 ${message}:`;
  const logStyle = 'color: #8B5CF6; font-weight: bold; font-size: 12px;';

  // oxlint-disable-next-line no-console
  console.log(logTitle, logStyle);

  if (data !== undefined) {
    // oxlint-disable-next-line no-console
    console.log(data);
  }
}

export function logListingPriceAtDecision(source: string, payload: {
  readonly listingPrice?: number;
  readonly listingRateAt?: number;
  readonly hasListingPriceAt: boolean;
}): void {
  logDebug('Price drift URL payload decision', {
    source,
    ...payload,
    reason: payload.hasListingPriceAt ? 'attached' : 'missing_listing_price_or_rate_at'
  });
}
